
import Vue from 'vue';
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import { VIEW_COMPANIES, UPDATE_COMPANIES } from '@/consts/permissions';
import each from 'lodash/each';
import groupBy from 'lodash/groupBy';
import { userCheck } from '@/api/fidaApi';
import {
  reportMenu,
  VMDMenu,
  toolsMenu,
  academyMenu,
  settingMenu,
  SETTING_MENU_ITEMS
} from '../../util/mockData/menuList';
import { addWeeks, startOfWeek } from 'date-fns';
import { handleErrorUI } from '@/util/error';
import CryptoJS from 'crypto-js';
import { getAuthoritiesObj } from '@/util/authoritiesCheck';
import { checkPermission } from '@/api/utils';
import { APIUpdateLangSSO } from '@/api/authSSO';
import store from '@/store';
import Gleap from 'gleap';
import { updateTitle } from '@/util/userUtils';
import moment from 'moment';
// import TopbarMemosButton from '@/components/Memo/TopbarMemosButton.vue';
// import AiModal from '../Common/AiModal.vue';

const stateMap = {
  [VIEW_COMPANIES]: 'settings:company',
  [UPDATE_COMPANIES]: 'settings:company'
};

export default {
  name: 'ContainerHeader',
  // components: {
  //   TopbarMemosButton
  // },
  data() {
    return {
      activeTab: 'chat',
      show: false,
      isDemo: false,
      isuserCheck: false,
      isPulseAllow: false,
      imageURL: '',
      user: {},
      releaseShow: false,
      accessibleModules: {},
      showNews: false,
      showVMD: false,
      showTools: false,
      showSetting: true,
      accessibleReportMenu: [],
      accessibleVMDMenu: [],
      accessibleToolsMenu: [],
      accessibleAcademyMenu: [],
      accessibleSettingMenu: [],
      viewPermission: {
        'settings:company': true
      },
      toggleLeftMiniDrawer: true,
      isEventAdd: false,
      expanded: false,
      toggleLeftDrawer: false,
      link: '/',
      appStatus: false,
      renderAi: false,
      isOpen: false,
      profileLoading: true,
      userDetail: {
        name: 'Yamada Taro',
        role: 'Store Manager at 113 - Shibuya',
        email: 'y.taro@mycompany.com'
      }
    };
  },
  computed: {
    validateIt() {
      return this.$store.state.overview.loadingApi;
    },
    isCorrectLocation() {
      return (
        window.location.origin === 'https://app.flow-insight.com' ||
        window.location.origin === 'https://stg-app.flow-insight.com'
      );
    },
    // validateIt(){
    //   return this.renderAi && (
    //     localStorage.getItem('tenentID') == 't9jzgqr8vcyzwwQsZ' ||
    //     localStorage.getItem('tenentID') == '57Xs6yMzdimQibLFq' ||
    //     localStorage.getItem('tenentID') == 'yXXPBT4ccGMWYdExx' ||
    //     localStorage.getItem('tenentID') == 'yXXPBT4ccGMWYdExx'
    //   )
    // },
    ...mapState('user', [
      'profile',
      'userPermissions',
      'defaultSettings',
      'clientProfile'
    ]),
    ...mapState('user', ['kpiLabelValue']),
    ...mapState('store', ['stores']),
    ...mapGetters('user', [
      'getStoreNameList',
      'getStoreCodeList',
      'getProfile'
    ]),
    ...mapGetters('user', ['getLocale', 'isAuthenticated', 'getToken']),
    ...mapGetters('tenant', ['config']),
    ...mapGetters('filter', [
      'getStoreCodesList',
      'getDaysOfWeekList',
      'getStartingPeriod',
      'getEndingPeriod',
      'getStartingCompared',
      'getEndingCompared',
      'getCustomCalenderState',
      'getCustom445DateRange'
    ]),
    showSettingsItem() {
      return SETTING_MENU_ITEMS.map(v => this.viewAllowed(v)).some(Boolean);
    },
    admin() {
      let checkAdmin = this.$store.state?.user?.profile?.email.startsWith(
        'botadmin@'
      );
      return checkAdmin;
    }
  },
  watch: {
    profile: function(newValue) {
      this.accessibleModules = this.profile.accessibleModules;
    },
    userPermissions() {
      this.generateAllMenus();
    },
    stores() {
      this.updateMixpanelUser();
    },
    $route: function(newValue) {
      this.link = newValue.name;
    }
  },
  async created() {
    //
    const checkRenderAi = setInterval(() => {
      if (window['renderAi']) {
        this.renderAi = true;
        clearInterval(checkRenderAi);
      }
    }, 200);
    //
    try {
      this.isuserCheck = userCheck();
      if (
        localStorage.getItem('tenentID') == 'A9Lqp7y4MWifcwHn9' ||
        localStorage.getItem('tenentID') == 'PLzQB8s92mDSj8Z4E' ||
        localStorage.getItem('tenentID') == 't9jzgqr8vcyzwwQsZ' ||
        localStorage.getItem('tenentID') == '57Xs6yMzdimQibLFq'
      ) {
        this.isPulseAllow = true;
      }
      // this.displayChat();
      const session = await this.clientProfile;
      if (!session) return;
      // await this.initialize();
      if (Object.keys(this.defaultSettings).length === 0) {
        const user = await this.$repo.user.getUser('me');
        const userDetails = this.defaultSettings;

        this.setDefaultSettings({ ...userDetails, user });
        if (Object.keys(this.userPermissions).length === 0) {
          let permissions = await getAuthoritiesObj(user?.roles);
          this.setUserPermissions(permissions);
        }
      }
      if (Object.keys(this.userPermissions).length > 0) {
        this.generateAllMenus();
      }
      // this.$intercom.shutdown();
      //this.bootIntercom();
      /*if (!this.$intercom.isBooted) {
        this.bootIntercom();
      }
      this.updateIntercom();
      */
      // Gleap.open();
      //this.getLocale
      Gleap.setLanguage(this.getLocale);
      this.updateGleap();
      this.initializeWootrics();
    } catch (err) {
      handleErrorUI(err);
    }
  },
  mounted() {
    window['handlePromptClick'] = this.handlePromptClick;
    window.fetchChatPrompt = this.fetchChatPrompt;

    document.addEventListener('click', this.handleClickOutside);
    this.fetchProfilePicture();
    this.isDemo = this.viewAllowed('FlowAssistantEdit');
    if (this.isAuthenticated) {
      if (localStorage.getItem('storeCodes')) {
        this.setStoreCodes({
          storeCodes: localStorage.getItem('storeCodes').split(',')
        });
      }
      this.setRetailCalendar({
        dates: JSON.parse(localStorage.getItem('retailCalendar'))
      });
      this.setStartingPeriod({
        startingPeriod: localStorage.getItem('startingPeriod')
      });
      this.setEndingPeriod({
        endingPeriod: localStorage.getItem('endingPeriod')
      });
      this.setStartingCompared({
        startingCompared: localStorage.getItem('startingCompared')
      });
      this.setEndingCompared({
        endingCompared: localStorage.getItem('endingCompared')
      });
      this.setLibraryStartingPeriod({
        startingPeriod:
          localStorage.getItem('startingLibraryPeriod') ??
          startOfWeek(new Date())
      });
      this.setLibraryEndingPeriod({
        endingPeriod: localStorage.getItem('endingLibraryPeriod') ?? new Date()
      });
      this.setLibraryStartingCompared({
        startingCompared:
          localStorage.getItem('startingLibraryCompared') ??
          addWeeks(startOfWeek(new Date()), -1)
      });
      this.setLibraryEndingCompared({
        endingCompared:
          localStorage.getItem('endingLibraryCompared') ??
          addWeeks(new Date(), -1)
      });
      this.setCustomCalenderFlag({
        endingCompared: localStorage.getItem('useCustomCalender')
      });

      let selectedKPI = localStorage.getItem('selectedTrafficKPI');

      let url_string = window.location.href;
      let url = new URL(url_string);
      let req = url;
      if (selectedKPI !== undefined) {
        this.getLocalStoreKPI({ selectedKPI, req });
      } else {
        this.getLocalStoreKPI({ selectedKPI: [], req });
      }
    }
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleFlowAiClick() {
      localStorage.removeItem('flowAiDismissed');
      this.showChat();
      localStorage.setItem('dashboardMemosRailOpen', 'false');
      localStorage.setItem('dashboardRailType', 'memos');
      window.dispatchEvent(new CustomEvent('flow:rail:close'));
    },
    openMemosDashboard() {
      const railOpen = localStorage.getItem('dashboardMemosRailOpen') === 'true';
      if (railOpen) {
        window.dispatchEvent(new CustomEvent('flow:rail:close'));
        return;
      }
      window.dispatchEvent(
        new CustomEvent('flow:rail:open', { detail: { type: 'memos' } })
      );
    },
    ...mapActions('overview', ['fetchOverview']),
    ...mapMutations('user', [
      'setLocale',
      'setUserPermissions',
      'setDefaultSettings'
    ]),

    ...mapMutations('home', ['setPlaceHolder']),
    ...mapMutations('distribution', ['getLocalStoreKPI']),
    ...mapMutations('filter', [
      'setStoreCodes',
      'setStartingPeriod',
      'setEndingPeriod',
      'setStartingCompared',
      'setEndingCompared',
      'setCustomCalenderFlag',
      'setRetailCalendar',
      'setCalendarDatesToStore'
    ]),
    ...mapMutations('marketplace', [
      'setLibraryStartingPeriod',
      'setLibraryEndingPeriod',
      'setLibraryStartingCompared',
      'setLibraryEndingCompared'
    ]),
    ...mapActions('user', ['clearSession', 'fetchKpiPreferences', 'logout']),
    ...mapActions('user', [
      'fetchKpiPreferences'

      // , 'fetchKpiPreferences2'
    ]),
    ...mapActions('tenant', ['reset']),
    ...mapActions({
      initialize: 'tenant/initialize'
    }),
    setActive(tab) {
      this.activeTab = tab;
    },
    showChat() {
      // this.$router.push('/chat');
      this.activeTab = 'chat';
      window?.showChat();
    },
    showChat2() {
      // this.$router.push('/chat');
      this.activeTab = 'chat';
      window?.showChat(true);
    },
    closeChat() {
      // this.$router.push('/');
      this.activeTab = 'home';
      window?.close();
    },
    getParamsForOverview(botName) {
      let stC = this.getStoreCodesList;
      if (!stC) {
        return;
      }
      const todayMoment = moment();

      if (
        botName === 'today_progress' ||
        botName === 'morning_brief' ||
        botName === 'todays_peak_hours' ||
        botName === 'expected_peak_hours'
      ) {
        const isYesterday = botName === 'morning_brief';
        const targetMoment = isYesterday
          ? todayMoment.clone().subtract(1, 'days')
          : todayMoment;

        const targetDate = targetMoment.format('YYYY-MM-DD');
        const compareDate = targetMoment
          .clone()
          .subtract(7, 'days')
          .format('YYYY-MM-DD');

        return {
          startDate: targetDate,
          endDate: targetDate,
          compareStartDate: compareDate,
          compareEndDate: compareDate,
          storeCodes: stC,
          daysOfWeek: this.getDaysOfWeekList,
          useCustomCalender: this.getCustomCalenderState,
          groupByMetricKey: true,
          comparisonYKPIMetricKey: ([...this.kpiLabelValue][0] ?? {})?.value,
          forAi: true
          // kpis: this.customSort.join(',')
        };
      } else if (botName === 'this_week_progress') {
        const weekStart =
          this.getResolvedWeekStartIndex() === 1 ? 'monday' : 'sunday';

        const today = todayMoment.format('YYYY-MM-DD');

        let startOfWeek;

        if (weekStart === 'sunday') {
          startOfWeek = todayMoment
            .clone()
            .startOf('week')
            .format('YYYY-MM-DD'); // Sunday
        } else if (weekStart === 'monday') {
          startOfWeek = todayMoment
            .clone()
            .isoWeekday(1)
            .format('YYYY-MM-DD'); // Monday (this week)
        }

        const compareToday = todayMoment
          .clone()
          .subtract(7, 'days')
          .format('YYYY-MM-DD');
        const compareStartOfWeek = moment(startOfWeek)
          .subtract(7, 'days')
          .format('YYYY-MM-DD');

        return {
          startDate: startOfWeek,
          endDate: today,
          compareStartDate: compareStartOfWeek,
          compareEndDate: compareToday,
          storeCodes: stC,
          daysOfWeek: this.getDaysOfWeekList,
          useCustomCalender: this.getCustomCalenderState,
          groupByMetricKey: true,
          comparisonYKPIMetricKey: ([...this.kpiLabelValue][0] ?? {})?.value,
          forAi: true
          // kpis: this.customSort.join(',')
        };
      } else {
        return {
          startDate: this.getStartingPeriod,
          endDate: this.getEndingPeriod,
          compareStartDate: this.getStartingCompared,
          compareEndDate: this.getEndingCompared,
          storeCodes: stC,
          daysOfWeek: this.getDaysOfWeekList,
          useCustomCalender: this.getCustomCalenderState,
          groupByMetricKey: true,
          comparisonYKPIMetricKey: ([...this.kpiLabelValue][0] ?? {})?.value,
          forAi: true
          // kpis: this.customSort.join(',')
        };
      }
    },
    formatAiPromptDateContext(dateInput, label) {
      if (!dateInput) return '';

      const date = moment(dateInput);
      if (!date.isValid()) return '';

      return `${label}: ${date.format('YYYY-MM-DD')} (${date.format('dddd')})`;
    },
    getResolvedWeekStartIndex() {
      const sources = [
        localStorage.getItem('WeekStartDay'),
        this.$store?.state?.user?.startWeek,
        this.$store?.state?.user?.defaultSettings?.weekStartDay,
        this.defaultSettings?.weekStartDay
      ];

      const normalized = sources
        .find(value => typeof value === 'string' && value.trim())
        ?.trim()
        .toLowerCase();

      return normalized?.startsWith('mon') ? 1 : 0;
    },
    formatAiPromptRangeContext(label, startDate, endDate) {
      const start = this.formatAiPromptDateContext(startDate, `${label} start`);
      const end = this.formatAiPromptDateContext(endDate, `${label} end`);
      return [start, end].filter(Boolean).join('\n');
    },
    getAiPromptDates(botName) {
      const todayMoment = moment();
      const weekStartsOn = this.getResolvedWeekStartIndex();

      if (botName === 'today_progress' || botName === 'todays_peak_hours') {
        return {
          selectedStart: todayMoment,
          selectedEnd: todayMoment,
          compareStart: todayMoment.clone().subtract(7, 'days'),
          compareEnd: todayMoment.clone().subtract(7, 'days')
        };
      }

      if (botName === 'morning_brief') {
        const yesterday = todayMoment.clone().subtract(1, 'days');
        return {
          selectedStart: yesterday,
          selectedEnd: yesterday,
          compareStart: yesterday.clone().subtract(7, 'days'),
          compareEnd: yesterday.clone().subtract(7, 'days')
        };
      }

      if (botName === 'this_week_progress') {
        const selectedStart = moment(
          startOfWeek(todayMoment.toDate(), { weekStartsOn })
        );
        const selectedEnd = todayMoment.clone();
        return {
          selectedStart,
          selectedEnd,
          compareStart: selectedStart.clone().subtract(7, 'days'),
          compareEnd: selectedEnd.clone().subtract(7, 'days')
        };
      }

      return {
        selectedStart: this.getStartingPeriod,
        selectedEnd: this.getEndingPeriod,
        compareStart: this.getStartingCompared,
        compareEnd: this.getEndingCompared
      };
    },
    buildAiPromptContext(botName) {
      const weekStart = this.getResolvedWeekStartIndex() === 1 ? 'monday' : 'sunday';
      const weekStartLine = `Week start day: ${
        weekStart === 'monday' ? 'Monday' : 'Sunday'
      }`;
      const dates = this.getAiPromptDates(botName);

      return [
        weekStartLine,
        this.formatAiPromptRangeContext('Selected period', dates.selectedStart, dates.selectedEnd),
        this.formatAiPromptRangeContext('Compared period', dates.compareStart, dates.compareEnd)
      ].join('\n');
    },
    buildPromptPayload(prompt) {
      if (!prompt || typeof prompt !== 'object') return prompt;

      const dateContext = this.buildAiPromptContext(prompt.botname);
      if (!dateContext) return prompt;

      const appendContext = value => {
        if (typeof value !== 'string' || !value.trim()) {
          return dateContext;
        }
        if (value.includes(dateContext)) return value;
        return `${value.trim()}\n\n${dateContext}`;
      };

      return {
        ...prompt,
        prompt: appendContext(prompt.prompt),
        query: appendContext(prompt.query),
        dateContext
      };
    },
    async handlePromptClick(prompt, clickLocation) {
      window?.showChat(true);
      // let flowAiPrompt = Object.entries(
      //   this.$store.state.target.prompts
      // ).filter(([key]) => key.startsWith('Dashboard') && key !== 'Dashboard');
      // let allD = flowAiPrompt.map(([name, config]) => config.botname);
      // const res = await this.fetchChatPrompt(prompt);
      // if (res) {
      // window.fetchChatPrompt = fetchChatPrompt;
      window.submitPrompt(this.buildPromptPayload(prompt), true);
      this.activeTab = 'chat';
      // return res;
      // }
      setTimeout(() => {
        this.show = false;
      }, 1500);
      // let { profile } = this.$store.state['user'];
      // const botName = this.$store.state.user.translate[prompt?.botname];
      // allD.includes(prompt?.botname)?"Flow Ai": botName
      // Vue.prototype.$mixpanel?.track('Flow Ai', {
      //   email: profile?.email,
      //   promptName: prompt?.botname,
      //   promptType: prompt?.botname || '',
      //   click_location: clickLocation || '',
      //   store_count: this.getStoreCodesList,
      //   selected_date_range:
      //     this.getStartingPeriod + '~' + this.getEndingPeriod,
      //   compare_date_range:
      //     this.getStartingCompared + '~' + this.getEndingCompared
      // });
    },
 async fetchChatPrompt(obj) {

  // Always fetch profile early
  let { profile } = this.$store.state['user'];
  let clickLocation = this.clickLocation || '';

  let params = this.getParamsForOverview(obj.botname);
  let res = null;

  if (params) {
    let str = JSON.stringify(params);
    params.trackLatest = { callerId: 'home', value: str };
    res = await this.fetchOverview(params);
  }

  // ---- 🔥 TRACK ONE TIME HERE — ALWAYS EXACTLY ONCE ----
  Vue.prototype.$mixpanel?.track('Flow Ai', {
    email: profile?.email,
    promptName: obj?.botname,
    promptType: obj?.botname || '',
    click_location: clickLocation,
    store_count: this.getStoreCodesList,
    selected_date_range: this.getStartingPeriod + '~' + this.getEndingPeriod,
    compare_date_range: this.getStartingCompared + '~' + this.getStartingCompared
  });
  // ------------------------------------------------------

  // Return if API returned something
  return res;
},

    drawerHandler() {
      if (this.isEventAdd) {
        this.toggleLeftMiniDrawer = true;
      } else {
        this.toggleLeftMiniDrawer = false;
      }
      this.isEventAdd = !this.isEventAdd;
    },
    handleMouseOver() {
      if (this.isEventAdd) return;
      this.toggleLeftMiniDrawer = false;
    },
    handleMouseOut() {
      if (this.isEventAdd) return;
      this.toggleLeftMiniDrawer = true;
    },
    async fetchProfilePicture() {
      this.profileLoading = true;
      // try {
      const responce = await this.$repo.user.getProfilePicture();
      this.imageURL = responce;
      if (!this.imageURL) {
        const { profile } = this.$store.state.user;
        if (profile) {
          const { firstName, lastName } = profile;
          const concatName = (firstName[0] || '') + (lastName[0] || '');
          const obj = {
            name: (concatName && concatName.toUpperCase()) || '',
            color: '#999999'
          };
          this.setPlaceHolder(obj);
        }
      }
      if (this.imageURL == null) {
        this.imgCheck = true;
      } else {
        this.imgCheck = false;
      }
      this.profileLoading = false;
      // } catch () {
      // }
    },
    // displayChat() {
    //   const usrChat = localStorage.getItem('usernameChat');
    //   const tokenChat = this.getToken;
    //   const lang = this.getLocale;

    //   var appStatus = true;
    //   /*if (localStorage.getItem('status') == 'production') {
    //     this.appStatus = true;
    //   } else {
    //     this.appStatus = false;
    //   }*/

    //   var ip = localStorage.getItem('chatIP');
    //   var isprod = localStorage.getItem('chatIsProd');

    //   if (usrChat != null) {
    //     var obj = {
    //       token: tokenChat,
    //       lang: lang,
    //       isSandbox: isprod
    //     };

    //     obj.addBotCallback = function() {
    //       window.open('/Explore', '_self');
    //     };

    //     //  window.renderFlowChat('flow-chat', obj);
    //     window.flowLoadChat('flow-chat', obj);
    //     window.intercomSettings = {
    //       alignment: 'right',
    //       horizontal_padding: 85,
    //       vertical_padding: 65
    //     };
    //   }
    // },
    generateAllMenus() {
      this.generateMenu(reportMenu, 'accessibleReportMenu');
      this.generateMenu(VMDMenu, 'accessibleVMDMenu');
      this.generateMenu(toolsMenu, 'accessibleToolsMenu');
      this.generateMenu(academyMenu, 'accessibleAcademyMenu');
      this.generateMenu(settingMenu, 'accessibleSettingMenu');
    },
    displayMenu(name) {
      if (name === 'tools') {
        return ['FlowLogView', 'FlowImportlogView', 'FlowStoreManagementView']
          .map(v => this.viewAllowed(v))
          .some(Boolean);
      }
      return false;
    },
    openServiceLink() {
      window.open('https://www.flow-solutions.com/agreements', '_blank');
    },
    getClicker() {
      Vue.prototype?.$mixpanel?.track('Clicker', {
        referrer: document.referrer
      });
      if (this.getLocale === 'en') {
        window.open('https://www.flow-solutions.com/en/clicker-lp', '_blank');
        return;
      }
      window.open('https://www.flow-solutions.com/clicker-lp', '_blank');
    },
    releaseShows() {
      window.open('https://flow-platform.canny.io/changelog', '_blank');
    },
    helpCenterShows() {
      if (this.getLocale === 'en') {
        window.open('https://help.flow-insight.com/en', '_blank');
        return;
      }
      window.open('https://help.flow-insight.com/ja', '_blank');
    },
    // apidocumentShows() {
    //   window.open(
    //     'https://documenter.getpostman.com/view/11648417/2s9YXo2zjZ#85415275-1ff9-487a-825d-508e60c09bdd',
    //     '_blank'
    //   );
    // },
    apidocumentShows() {
      const apiDocumentLink = this.$store.state.user.translate
        .api_documentation_link;
      window.open(apiDocumentLink, '_blank');
    },
    ftpGuideShows() {
      const url = this.$store.state.user.translate.nav_ftp_guide_link;
      if (url && typeof url === 'string') {
        window.open(url, '_blank');
      } else {
        console.error('Invalid FTP guide link:', url);
      }
    },
    async signout() {
      // const session = await this.$repo.session.fetch();
      try {
        Gleap.clearIdentity();
        await this.logout('');
         this.setCalendarDatesToStore({
        selectedOption: JSON.parse(localStorage.getItem('vuex') || "{}")?.["user"]?.defaultSettings?.storeSelectPeriods,
        comparedOption: '',
        selectedPeriod: '',
        comparedPeriod: ''
      });
        updateTitle();
        this.$store.commit('user/setTranslationsKpi', {});
      } catch (ex) {
        console.log('Error on logout', ex);
      }
    }, // signout

    backToV2() {
      window.open('https://staging-ta.flow-insight.com', '_blank');
    },
    redirectTo(routeName) {
      // if( routeName =='Templates' || routeName =='Explore')
      // {
      //   this.$router.push({ name: routeName }).catch(_ => {});
      //   return;
      // }

      this.link = routeName;
      if (routeName) {
        Vue.prototype?.$mixpanel?.track(`navigate to ${routeName}`, {
          referrer: document.referrer
        });
        this.toggleLeftMiniDrawer = false;
        this.$router.push({ name: routeName }).catch(_ => {});
      }
    },
    openSideBar() {
      this.toggleLeftMiniDrawer = false;
    },

    generateMenu(menuList, accessibleMenuOptions) {
      const accessibleMenu = Object.keys(menuList).map((reportKey, key) => {
        if (this.viewAllowed(Object.values(menuList)[key].code)) {
          return menuList[reportKey];
        }
      });
      this[accessibleMenuOptions] = accessibleMenu.filter(Boolean);
    },
    async setupLocale(locale) {
      this.setLocale({ locale });
      import(
        /* webpackInclude: /(ja|en-us)\.js$/ */
        'quasar/lang/' + locale
      ).then(lang => {
        this.$q.lang.set(lang.default);
      });
      this.$root.$i18n.locale = locale;
      APIUpdateLangSSO({ lang: locale });
      const kpipref = await this.fetchKpiPreferences();
      // const kpipref2 = await this.fetchKpiPreferences2();
      this.$router.go(0);
    }, // setupLocale
    viewAllowed(name) {
      return checkPermission(name);
    },
    generateHash(user_id) {
      const hash = CryptoJS.HmacSHA256(
        user_id,
        '_I7ywUfT_YEV81RC0Kid7HYAw9Posnk3t1KAPT0W'
      );
      const hashInHex = CryptoJS.enc.Hex.stringify(hash);
      return hashInHex;
    },

    updateGleap() {
      let addonsIds = '';
      let plansIds = '';
      let codes = '';

      const userdetails = this.defaultSettings?.user.response.userDetails ?? {};

      if (userdetails?.addons?.length) {
        addonsIds = userdetails.addons.map(x => x._id).join(',');
      }

      if (userdetails?.plans?.length) {
        plansIds = userdetails.plans.map(x => x._id).join(',');
        codes = userdetails.plans.map(x => x.code).join(',');
      }

      // Ensure nested objects exist
      userdetails.tenant = userdetails.tenant ?? {};

      userdetails.tenant.addonsIds = addonsIds;
      userdetails.tenant.plansIds = plansIds;
      userdetails.plans = codes;

      const user = this.clientProfile ?? {};
      const phone =
        (userdetails?.profile?.phoneCountryCode ?? '') +
        (userdetails?.profile?.phoneNumber ?? '');

      Gleap.identify(user?._id ?? '', {
        name: `${user?.fullName ?? ''}`,
        email: user?.email ?? '',
        phone: phone,
        plan: userdetails.tenant.planIds,
        companyId: userdetails.tenant._id,
        companyName: userdetails.tenant.title
      });
    },

    initializeWootrics() {
      let wootricScript = document.createElement('script');
      wootricScript.setAttribute(
        'src',
        'https://cdn.wootric.com/wootric-sdk.js'
      );
      wootricScript.async = true;
      wootricScript.onload = () => {
        window.wootricSettings = {
          email: this.clientProfile?.email,
          created_at: Math.floor(Date.now() / 1000), //Date.now(),
          account_token: 'NPS-c96acd0d' // This is your unique account token.
        };
        window.wootric('run');
      };

      document.head.appendChild(wootricScript);
    },
    updateMixpanelUser() {
      Vue.prototype?.$mixpanel?.people.unset([
        '$email',
        '$phone',
        '$first_name',
        '$last_name'
      ]);
      Vue.prototype?.$mixpanel?.people.set({
        $store_names: this.getStoreNameList,
        $store_codes: this.getStoreCodeList
      });
    },
    toAppStore() {
      window.open(
        'https://apps.apple.com/jp/app/flow-for-mobile/id1504601424?hsCtaTracking=a4ca061c-5db4-4d74-9817-d9af59ea22fe%7C6c5b6e22-41e3-4b28-9ed3-82c5eb04de84',
        '_target'
      );
    },
    toPlayStore() {
      window.open(
        'https://play.google.com/store/apps/details?id=com.flow.go&hl=ja&gl=JP&hsCtaTracking=3f15eddd-e298-4af9-a58b-0bf9de9562b1%7Cbb279490-87f4-47ee-b762-4c61ed6a57a7',
        '_target'
      );
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    handleClickOutside(event) {
      if (!this.$refs.dropdownRef?.contains(event.target)) {
        this.isOpen = false;
      }
    },
    uploadPhoto() {
      const fileInput = this.$refs.fileInput;

      if (fileInput && fileInput instanceof HTMLInputElement) {
        fileInput.click();
      } else {
        console.warn('fileInput not ready or is not an input element');
      }
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        console.log('Selected file:', file.name);
      }
    }
  } // methods
}; // export default
